module.exports = __webpack_public_path__ + "img/squirrel.e10327f3.jpg";